<template>
  <div class="content">
    <Header :title="'消息提醒'" />
    <div class="msg-wrap">
      <div class="tab-head">
        <input :class="[tabIndex === 0 ? 'active' : '']" type="button" value="奖励消息" @click="tabClick(0)">
        <input :class="[tabIndex === 1 ? 'active' : '']" type="button" value="系统通知" @click="tabClick(1)">
        <input :class="[tabIndex === 2 ? 'active' : '']" type="button" value="回复提醒" @click="tabClick(2)">
      </div>
      <div class="tab-body">
        <div class="tab">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
            <ul class="list">
              <li v-for="(item, index) in list" :key="index" class="list-item">
                <div class="date">{{ item.createdDate }}</div>
                <div class="msg">
                  <h3 v-show="tabIndex === 2">我的反馈</h3>
                  <p v-show="tabIndex === 2">{{ item.title }}</p>
                  <h3 v-show="tabIndex === 2">系统回复</h3>
                  <p>{{ item.content }}</p>
                </div>
              </li>
            </ul>
          </van-list>
        </div>
      </div>
      <nut-backtop :bottom="70" :duration="1000" :right="10" :z-index="10">
        <i class="iconfont back-top">&#xe66a;</i>
      </nut-backtop>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { List } from 'vant'
import { Toast } from '@nutui/nutui'
import { notificationHaveRead, notificationList } from '@/api/Personal/Message/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'

Vue.use(List)

export default {
  name: 'Message',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      tabIndex: 0,
      loading: false,
      finished: false,
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    tabClick(i) {
      this.tabIndex = i
      this.pageIndex = 1
      this.finished = false
      this.$cancelRequest()
      this.getList()
    },
    getList() {
      this.loading = true
      let type = 2
      if (this.tabIndex === 0) {
        type = 2
      } else if (this.tabIndex === 1) {
        type = 1
      } else if (this.tabIndex === 2) {
        type = 3
      }
      const params = {
        type,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      notificationList(params).then(res => {
        this.loading = false
        if (res && res.success) {
          if (res.data && res.data.rows) {
            if (this.pageIndex === 1) {
              this.list = res.data.rows
            } else {
              this.list = this.list.concat(res.data.rows)
            }
            this.pageIndex += 1
            this.finished = this.list.length >= res.data.total
            this.saveIds(res.data.rows)
          } else {
            this.finished = true
          }
        } else {
          Toast.fail(res.msg)
          this.finished = true
        }
      })
    },
    // 更新消息已读状态
    saveIds(rows) {
      const ids = []
      rows.forEach(item => {
        if (item.isRead === false) {
          ids.push(item.id)
        }
      })
      if (ids.length > 0) {
        notificationHaveRead(ids)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/styles/index.scss';

.content {
  width: 100%;
  height: calc(100% - 50px);
  overflow: hidden;
  padding: 15px 15px 80px 15px;
  box-sizing: border-box;
  position: relative;

  .msg-wrap {
    width: 100%;
    min-height: 0;
    height: auto;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;

    .tab-head {
      width: 321px;
      height: 36px;
      position: relative;
      margin: 20px auto 10px auto;
      display: flex;
      justify-content: space-between;

      input {
        width: 100px;
        height: 36px;
        line-height: 36px;
        appearance: none;
        border-radius: 5px;
        font-size: 15px;
        border: none;
        font-weight: 600;
        -webkit-appearance: none;
        background: #e6e6e6;
        color: #333333;
      }

      .active {
        color: #ffffff;
        @extend %colorGrident;
      }
    }

    .tab-body {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;
      position: relative;

      .tab {
        ul {
          li {
            width: 100%;
            min-height: 80px;
            height: auto;
            float: left;
            margin: 10px 0;

            .date {
              width: 100%;
              height: 41px;
              line-height: 41px;
              text-align: center;
              font-size: 12px;
              color: #999999;
            }

            .msg {
              box-sizing: border-box;
              width: calc(100% - 10px);
              margin: 5px auto;
              min-height: 0;
              height: auto;
              overflow: hidden;
              background: #ffffff;
              border-radius: 5px;
              @extend %boxShadow;
              padding: 20px;

              h3 {
                font-size: 15px;
                text-align: center;
                color: #ffa200;
                margin: 0;
                padding: 10px 0;
                line-height: 26px;
              }

              p {
                margin: 0;
                padding: 0;
                line-height: 24px;
                color: #b3b3b3;
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    .back-top {
      font-size: 45px;
      color: #d08d03;
    }
  }
}
</style>
